import UiModal from '../UiModal/UiModal'
import { getVkAuthModel } from '../VKConnect'
import Form from '../../Form/Form'
import { defaultRules } from '../../Form/default-rules'
import { saleEndDate } from '../SaleEndDate/SaleEndDate'
import { Timer } from '../Timer/Timer'
import { createElement } from '../../utils/render'
import { SubmitType } from '../../utils/const'
import { translate } from '../../utils/translations'
import { showAutopaymentModal } from '../../../components/popups/v1/AutopayModal/scripts'
import { initCommunication } from '../../../partials/communication/scripts'

export class PriceModal extends UiModal {
  constructor(template, { blockName, tariffData }) {
    super(template, {
      blockTriggerName: blockName,
      outerScroll: true,
      isIndent: false,
      wrapperClass: 'price-modal'
    })

    this.tariffData = tariffData
    this.formElement = null
    this.formInstance = null
    this._timerObserver = null
  }

  _initTimer() {
    const timerWrapper = this.element.querySelector('.price-modal__timer-block')

    if (timerWrapper && this.tariffData.sale) {
      this._timerObserver = (time) => new Timer({ time, timerWrapper })
      saleEndDate.addObserver(this._timerObserver)

      return
    }

    timerWrapper?.remove()
  }

  _b2bInit() {
    const b2b = this.element.querySelector('.ui-checkbox-field__input[name="is_jur_person"]')
    const companyInput = this.element.querySelector('[data-field="b2b"]')
    const companyField = companyInput?.closest('.form__input--hidden')

    if (!b2b || !companyInput || !companyField) {
      return
    }

    setTimeout(() => {
      if (b2b.checked) {
        companyField.classList.add('form__input--show')
      }
    }, 100)

    b2b.addEventListener('change', () => {
      companyField.classList.toggle('form__input--show')
      companyInput.disabled = !b2b.checked
    })
  }

  _initSubmitTypeSwitch() {
    const formTypes = this.element.querySelector('.price-modal__form-types')
    const buttonText = this.element.querySelector('.price-modal__form-button .ui-button__text')

    if (!formTypes || !buttonText) {
      return
    }

    const ButtonText = {
      [SubmitType.PAY]: translate('form.button.pay'),
      [SubmitType.CONSULT]: translate('form.button.consultation')
    }

    formTypes.addEventListener('change', (evt) => {
      const chosenType = evt.target.value

      buttonText.textContent = ButtonText[chosenType] ? ButtonText[chosenType] : ButtonText[SubmitType.CONSULT]
    })
  }

  _fillData() {
    const card = this.element.querySelector('.price-modal__price-content')
    const typeHiddenField = this.element.querySelector('input[name="type"]')
    const tariffTitleHiddenField = this.element.querySelector('input[name="tariff_title"]')
    const nomenclatureHiddenField = this.element.querySelector('input[name="nomenclature_id"]')

    if (!card || !typeHiddenField || !tariffTitleHiddenField || !nomenclatureHiddenField) {
      return
    }

    typeHiddenField.value = this.tariffData.tariffType ?? ''
    tariffTitleHiddenField.value = this.tariffData.title ?? ''
    nomenclatureHiddenField.value = this.tariffData.nomenclature_id ?? ''

    const descriptions = (this.tariffData.descriptions ?? [])
      .map((item) => `<li class="price-modal__credit-item f f--12">${item}</li>`)
      .join('')

    const cardStr = card.outerHTML
      .replace(/#sale#/g, this.tariffData.sale ?? '')
      .replace(/#priceNew#/g, this.tariffData.price?.new ?? '')
      .replace(/#priceNewCurrency#/g, this.tariffData.price?.newCurrency ?? '')
      .replace(/#priceOld#/g, this.tariffData.price?.old ?? '')
      .replace(/#priceOldCurrency#/g, this.tariffData.price?.oldCurrency ?? '')
      .replace(/#descriptions#/g, descriptions)

    const newCard = createElement(cardStr)

    if (!this.tariffData.sale) {
      newCard.querySelector('.price-modal__sale')?.remove()
    }

    if (!this.tariffData.price?.old) {
      newCard.querySelector('.price-modal__secondary-price--old')?.remove()
    }

    if (!this.tariffData.sale && !this.tariffData.price?.old) {
      newCard.querySelector('.price-modal__secondary-prices')?.remove()
    }

    if (!(this.tariffData.descriptions ?? []).length) {
      newCard.querySelector('.price-modal__credit-list')?.remove()
    }

    card.parentElement.replaceChild(newCard, card)
  }

  _showAfterSubmitModal(type) {
    return this.formInstance?._showAfterSubmitModal(type)
  }

  _closeWithCommunicationOrCallback() {
    if (this._showAfterSubmitModal() !== null) {
      this.close()
      return
    }

    if (this.callback && typeof this.callback === 'function') {
      this.callback('order') !== null && this.close()
    }
  }

  formSubmitHandler = async (evt) => {
    const type = evt.sendingResult.formData.get('submit_type')

    /* eslint-disable-next-line */
    !isGbHost && window.$analytics?.push('fl-show-form')
    window.$analytics?.push('tariff-subscribe-button-click', {
      tariffName: this.tariffData.name,
      blockName: this.blockTriggerName
    })

    /* eslint-disable-next-line */
    if (this.tariffData.isDefault && type === SubmitType.CONSULT && !enabledAutoPaymentForConsult) {
      this._closeWithCommunicationOrCallback()
      return
    }

    if (!this.tariffData.payments?.length) {
      this._closeWithCommunicationOrCallback()
      return
    }

    const isAutopaymentShown = await showAutopaymentModal({
      nomenclatureId: this.tariffData.nomenclature_id,
      methods: this.tariffData.payments,
      type,
      blockName: this.blockTriggerName,
      callback: (afterType) => this._showAfterSubmitModal(afterType)
    })

    if (isAutopaymentShown) {
      this.close()
      return
    }

    this._closeWithCommunicationOrCallback()
  }

  async beforeMounted() {
    this.formElement = this.element.querySelector('.form')

    this._fillData()
    this._b2bInit()
    this._initTimer()
    this._initSubmitTypeSwitch()
    initCommunication(this.element)

    if (!this.formElement) {
      return
    }

    const vkConnectContainer = this.element.querySelector('[data-auth="vk-connect"]')
    const vkAuthModel = await getVkAuthModel([vkConnectContainer])
    this.formInstance = new Form({
      form: this.formElement,
      rules: defaultRules,
      vkAuthModel,
      blockName: this.blockTriggerName
    })
    this.formInstance.init()

    this.formElement.addEventListener('after-form-success', this.formSubmitHandler)
  }

  beforeUnmounted() {
    this.formElement?.removeEventListener('after-form-success', this.formSubmitHandler)

    if (this._timerObserver) {
      saleEndDate.removeObserver(this._timerObserver)
    }
  }
}
